export const ProductsCategory = ['Helados', 'Combos', 'Bombones', 'Shakes', 'Crepes', 'Parfaits']